export enum CustomizacaoMenuEnum {
    cadastro = 1,
    pedido = 2,
    administrativo = 3,
    produto = 4,
    financeiro = 5
}
